import React from "react";
import PropTypes from "prop-types";
import { Checkbox, FormControlLabel, CheckboxProps } from "@material-ui/core";
import useStyles from "./styles";

export default function CobeeCheckbox({
  className,
  label,
  ...rest
}: { className?: string; label?: string } & CheckboxProps) {
  const { checkbox } = useStyles();

  const checkboxComponent = (
    <Checkbox className={`${checkbox} ${className}`} disableRipple {...rest} />
  );

  if (label) {
    return <FormControlLabel control={checkboxComponent} label={label} />;
  }
  return checkboxComponent;
}

CobeeCheckbox.defaultProps = { className: undefined, label: undefined };

CobeeCheckbox.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
};
